<template>
  <main>
    <div id="teleport" />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <div
      style="height: 100dvh; width: 100vw; display: flex; align-items: center; justify-content: center; flex-direction: column; background-color: var(--background-color); position: fixed; top: 0px; left: 0px; z-index: 10000;"
      :class="[
        isLoaded ? 'pointer-events-none opacity-0 duration-300 delay-200' : ''
      ]"
      v-if="!isLaunched"
    >
      <img width="70" src="/rainbow_xl.png" style="transition-timing-function: cubic-bezier(0,.32,.24,1.3)" :class="[
        isLoaded ? 'opacity-0 scale-75 duration-300' : '',
        isStarted ? 'duration-300' : 'scale-0 opacity-0'
      ]">
    </div>

    <div class="w-6 h-6 bg-royal-400/0 fixed top-0 right-0 z-[999999]" @click="simulateNotch = !simulateNotch" v-if="isTest" />

    <div class="w-6 h-6 bg-royal-400/0 fixed top-0 left-0 z-[999999]" @click="colorThemeSetting = colorTheme === 'dark' ? 'light' : 'dark'" v-if="isTest" />

    <div class="w-6 h-6 bg-royal-400/0 fixed bottom-0 right-0 z-[999999]" @click="activeKeyboard = !activeKeyboard" v-if="isTest" />
    
    <div class=" bg-charcoal-500 text-white flex items-center justify-center fixed bottom-0 h-[45vh] w-full left-0 z-[99999]" @click="activeKeyboard = false" v-if="isTest && activeKeyboard">
      KEYBOARD
    </div>

    <div class="md:hidden fixed top-3 flex font-medium text-md px-5 items-center justify-between left-0 right-0 mx-auto z-[500000]" :class="[ statusColor === 'dark' ? 'text-white' : 'text-light-950' ]" v-if="simulateNotch">
      <p class="grow flex-1">12:35</p>

      <div class="h-8 text-charcoal-900 flex items-center justify-center rounded-full w-2/5 shrink-0 bg-charcoal-950" @click="() => isDebug = !isDebug">
      </div>

      <p class="grow text-right flex-1 whitespace-nowrap overflow-hidden">
        86%
      </p>
    </div>

    <div class="fixed top-14 bg-charcoal-950 overflow-auto no-scrollbar p-4 text-white h-30 left-6 right-6 mx-auto z-[500001]" v-show="isDebug" v-if="simulateNotch">
      
      <div id="debug" />

      {{ [ ...windowStore.debug.entries() ].map(([ key, value ]) => {
        return `${key}: ${value}`
      }).join('\n') }}
    </div>
 
    <div class="md:hidden fixed bottom-3 bg-charcoal-950 h-2 left-0 right-0 mx-auto rounded-full w-2/5 z-[500000] pointer-events-none" v-if="simulateNotch" />

    <!-- <div class="md:hidden fixed top-0 left-0 w-full h-full flex flex-col justify-between z-[500000] pointer-events-none" v-if="simulateNotch">
      <div class="flex justify-between">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8" viewBox="0 0 68.973 68.466">
          <path d="M0 68.466V0h68.973a68.678 68.678 0 0 0-38.551 11.784 69.2 69.2 0 0 0-25 30.358A68.549 68.549 0 0 0 0 68.466Z" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 -scale-x-100 -mr-[1px]" viewBox="0 0 68.973 68.466">
          <path d="M0 68.466V0h68.973a68.678 68.678 0 0 0-38.551 11.784 69.2 69.2 0 0 0-25 30.358A68.549 68.549 0 0 0 0 68.466Z" />
        </svg>
      </div>

      <div class="flex justify-between">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 -scale-y-100" viewBox="0 0 68.973 68.466">
          <path d="M0 68.466V0h68.973a68.678 68.678 0 0 0-38.551 11.784 69.2 69.2 0 0 0-25 30.358A68.549 68.549 0 0 0 0 68.466Z" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 -scale-y-100 -scale-x-100 -mr-[1px]" viewBox="0 0 68.973 68.466">
          <path d="M0 68.466V0h68.973a68.678 68.678 0 0 0-38.551 11.784 69.2 69.2 0 0 0-25 30.358A68.549 68.549 0 0 0 0 68.466Z" />
        </svg>
      </div>
    </div> -->
  </main>
</template>

<script lang="ts" setup>
import { Capacitor } from '@capacitor/core'
import { initApp } from '@/utils/native/useApp'
import { initLayout, setInsets } from '@/utils/native/useLayout'
import { notificationsInit } from '@/utils/native/usePushNotifications'
import { initIAP } from '@/utils/native/useIAP'
import { initKeyboard } from '@/utils/native/useKeyboard'
import UserStore from '@/store/user'
import WindowStore from '@/store/window'
import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { App } from '@capacitor/app'

import dayjs from 'dayjs'
import frLocale from 'dayjs/locale/fr'
import enLocale from 'dayjs/locale/en'

import timezone from 'dayjs/plugin/timezone'
import calendar from 'dayjs/plugin/calendar'
import updateLocale from 'dayjs/plugin/updateLocale'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import relativeTime from 'dayjs/plugin/relativeTime'
import { getDeviceLanguage } from './utils/native/useDevice'
import { SplashScreen } from '@capacitor/splash-screen'
import { admobInit } from './utils/native/useAdMob'
import { Filesystem, Directory } from '@capacitor/filesystem'
import { appsFlyerInit } from './utils/native/useAppsFlyer'

dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(updateLocale)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.tz.setDefault('Europe/Paris')

dayjs.extend(calendar)

dayjs.updateLocale('fr', {
  ...frLocale,
  weekStart: 1,
  relativeTime : {
    future: "dans %s",
    past: "il y a %s",
    s:  "qq. s.",
    m:  "1min.",
    mm: "%dmin.",
    h:  "1h.",
    hh: "%dh.",
    d:  "1j.",
    dd: "%dj.",
    M:  "1mo.",
    MM: "%dmo.",
    y:  "1a.",
    yy: "%da."
  }
})

dayjs.updateLocale('en', {
  ...enLocale,
  relativeTime : {
    future: "in %s",
    past: "%s ago",
    s:  "seconds",
    m:  "1min.",
    mm: "%dm.",
    h:  "1h.",
    hh: "%dh.",
    d:  "1d.",
    dd: "%dd.",
    M:  "1mo.",
    MM: "%dmo.",
    y:  "1y.",
    yy: "%dy."
  }
})

const isDebug = ref(false)

const userStore = UserStore()
const { currentUser, unreadConversationsCount, colorTheme, colorThemeSetting } = storeToRefs(userStore)
const windowStore = WindowStore()
const { titles } = storeToRefs(windowStore)
const icons: object = import.meta.glob(`@/assets/svg/**/*.svg`, { query: '?raw', import: 'default' })
const isTest = useRuntimeConfig().public.IS_NOTCH
const simulateNotch = ref(useRuntimeConfig().public.IS_NOTCH && !Capacitor.isNativePlatform())
const activeKeyboard = ref(false)


watch(() => currentUser.value?.language, async (language) => {
  const targetLanguage = language ?? await getCookie('lang') as string ?? await getDeviceLanguage()

  useNuxtApp().$i18n.setLocale(['fr', 'en'].includes(targetLanguage) ? targetLanguage : 'fr')

  dayjs.locale(targetLanguage)
  setCookie('lang', targetLanguage)
}, { immediate: true })

watch(activeKeyboard, () => {
  if (activeKeyboard.value) {
    if (process.client) window.dispatchEvent(new CustomEvent('show-keyboard'))
  } else {
    if (process.client) window.dispatchEvent(new CustomEvent('hide-keyboard'))}
})

if (process.client) {
  provide('icons', icons)
}

const isStarted = ref(false)
const isLoaded = ref(false)
const isLaunched = ref(false)
const statusColor = ref('dark')
const route = useRoute()

const updateColorTheme = async () => {
  const body = document.body

  if (body) {
    if (colorTheme.value === 'dark' && !((route?.name) as string ?? '').includes('admin')) {
      body.classList.add('dark')
    } else {
      body.classList.remove('dark')
    }
  }
}

watch(colorTheme, updateColorTheme)
watch(colorThemeSetting, async () => {
  await setCookie('colorMode', colorThemeSetting.value)
})

onMounted(async () => {
  setTimeout(() => isStarted.value = true)
  
  initLayout()
  initApp()
  admobInit()
  notificationsInit()
  initIAP()
  
  const { onShow, onHide } = initKeyboard()

  const mode = await getCookie('colorMode')
  colorThemeSetting.value = (mode ?? 'auto') as any
  updateColorTheme()

  setTimeout(() => {
    isLoaded.value = true
    SplashScreen.hide()

    setTimeout(() => initLayout(), 200)
  }, 500)

  setTimeout(async () => {
    isLaunched.value = true
    setTimeout(() => setTestInsets(), 100)
  }, 1000)

  const sessionReplayTracking = sessionReplayPlugin()
  
  const location = window.location.href
  if (useRuntimeConfig().public.ENVIRONMENT === 'production' && (location.includes('app.vibes.lgbt') || Capacitor.isNativePlatform())) {
    amplitude.add(sessionReplayTracking)
    amplitude.init(useRuntimeConfig().public.AMPLITUDE_API, {
      autocapture: {
        attribution: true,
        fileDownloads: true,
        formInteractions: true,
        pageViews: true,
        sessions: true,
        elementInteractions: false
      },
      serverZone: 'EU'
    })
  }

  window.addEventListener('show-keyboard', (e: any) => onShow({ keyboardHeight: window.innerHeight * 0.45 }))
  window.addEventListener('hide-keyboard', (e: any) => onHide())
  window.addEventListener('color', (e: any) => statusColor.value = e.detail)

  try {
    await Filesystem.readdir({
      path: 'emojis',
      directory: Directory.Cache
    })
  } catch (e) {
    Filesystem.mkdir({
      path: 'emojis-sm-animated',
      directory: Directory.Cache,
    })

    Filesystem.mkdir({
      path: 'emojis',
      directory: Directory.Cache,
    })

    Filesystem.mkdir({
      path: 'emojis-sm-static',
      directory: Directory.Cache,
    })
  }

  try {
    await Filesystem.readdir({
      path: 'uploads',
      directory: Directory.Cache
    })
  } catch (e) {
    Filesystem.mkdir({
      path: 'uploads',
      directory: Directory.Cache,
    })
  }

  try {
    await Filesystem.readdir({
      path: 'besties',
      directory: Directory.Cache
    })
  } catch (e) {
    Filesystem.mkdir({
      path: 'besties',
      directory: Directory.Cache,
    })
  }

  windowStore.initAudio()
})

watch(simulateNotch, () => setTestInsets())

const setTestInsets = () => {
  if (useRuntimeConfig().public.NODE_ENV === 'production') return
  
  if (simulateNotch.value) {
    const { width: windowWidth } = useWindowSize()
    const isMobile = computed(() => windowWidth.value <= 880)

    setInsets(isMobile.value ? 48 : 0, isMobile.value ? 26 : 0)
  } else {
    setInsets(0, 0)
  }
}

if (Capacitor.isNativePlatform()) {
  App.addListener('resume', () => {    
    setTimeout(() => initLayout())
  })
}

watch(titles, () => {
  useHead({
    titleTemplate: (titleChunk) => {
      const prepend = [ ...titles.value.values() ].filter(t => t.value).sort((a, b) => Number(b.createdAt) - Number(a.createdAt)).map(t => {

        return t.value + (t.path ? ` : ${t.path.join(' · ')}` : '')
      })[0] ?? ''
      
      return (unreadConversationsCount.value > 0 ? `(${unreadConversationsCount.value}) ` : '') + [ prepend, titleChunk, 'Vibes 🏳️‍🌈' ].filter(t => t).join(' · ')
    }
  })
}, { deep: true, immediate: true })
</script>

<style>
  :root {
    --background-color: #dff0f9;
  }

  @media (prefers-color-scheme: dark) {
    :root {
      --background-color: #1a1a1a; /* Dark background color */
    }
  }
</style>